var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"stage empty:hidden"},[(_vm.carousel.slides.length)?_c('Carousel',_vm._b({staticClass:"mx-auto",attrs:{"id":_vm.anchorName}},'Carousel',_vm.carousel,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }